export default __webpack_public_path__ + "static/media/sidebar-delete.3b8491ee.svg";